import React from "react";
import { Phone, Mail, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TalkToEngineering() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="fale-com-a-engenharia" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 flex flex-col items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.03]">
        <svg className="w-full h-full" width="100%" height="100%">
          <defs>
            <pattern id="eng-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#eng-grid)" />
        </svg>
      </div>

      {}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,var(--primary)_0%,transparent_45%)] opacity-10 pointer-events-none" />

      <div className="container relative z-10 px-4 mx-auto text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="inline-block py-1 px-3 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono tracking-widest mb-6 uppercase">
            Contato Engenharia
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 max-w-4xl mx-auto leading-tight">
            Estamos Prontos para seu <br className="hidden md:block" />
            <span className="text-primary">Próximo Desafio</span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
            Nossa equipe técnica está à disposição para discutir projetos
            críticos, retrofit e soluções personalizadas para sua infraestrutura.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
            {}
            <Link to="tel:+550000000000" className="group flex items-center gap-4 p-4 rounded-lg hover:bg-accent/5 transition-colors duration-300">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                <Phone className="w-5 h-5" />
              </div>
              <div className="text-left">
                <p className="text-sm text-muted-foreground font-medium mb-0.5">
                  Ligue para nós
                </p>
                <span className="text-lg font-semibold tracking-tight">(14) 3324-5757</span>
              </div>
            </Link>

            {}
            <div className="hidden sm:block w-px h-12 bg-border/50" />

            {}
            <Link to="mailto:contato@doctorice.com.br" className="group flex items-center gap-4 p-4 rounded-lg hover:bg-accent/5 transition-colors duration-300">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                <Mail className="w-5 h-5" />
              </div>
              <div className="text-left">
                <p className="text-sm text-muted-foreground font-medium mb-0.5">
                  Envie um e-mail
                </p>
                <span className="text-lg font-semibold tracking-tight">
                  contato@doctorice.com.br
                </span>
              </div>
            </Link>
          </div>

          <div className="mt-16 animate-bounce">
            <Button variant="ghost" size="icon" className="rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10" asChild>
              <Link to="#formulario-contato" aria-label="Rolar para o formulário">
                <ArrowDown className="w-6 h-6" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}